export function isMobileDevice() {
    return false;
}

export function isDesktopDevice() {
    return true;
}